import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Delivery } from '../app.urls';
import { LoaderService } from './loader.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class DeliveryService {
  disableProperty = new BehaviorSubject<any>(false);
  submitTestObs = new BehaviorSubject<any>(false);
  testLimit = new BehaviorSubject<any>(false);
  totalQ = new BehaviorSubject<any>(false);
  pdfToggle = new BehaviorSubject<any>(false);
  titleNameTest = new BehaviorSubject<any>(false);
  public notepaddevalue$ = new BehaviorSubject<any>("");
  public togleIcon = new BehaviorSubject<any>(false)
  public voiceNo = new BehaviorSubject<any>(11)
  public getNextPageEvent = new BehaviorSubject<any>(true)
  public calculatorvalue$ = new BehaviorSubject<any>("");
  public publicSchParam = new BehaviorSubject<any>("");
  private subjectPdf = new Subject<any>()
  savedAnswers = {
    testuuId: undefined,
    userTestuuId: undefined,
    answers: [] as any
  };
  questionsEvaluationDetailsData = {
    questionsEvaluationDetails: [] as any,
    examineeId: 0,
    scheduleId: 0,
    usertestid: 0
  };

  pdfToggleBtn = false;
  testDetails: any;
  isValidToNextBack: boolean = true;
  matrixQuestionValidations: MatrixQuestionValidation[] = [];
  isSubmitted: boolean = false;

  saveAnswer$: BehaviorSubject<any>;
  validQuestionSubject: Subject<number> = new Subject();

  itemName$: BehaviorSubject<any>;
  questionAttempted: BehaviorSubject<boolean>;
  showTools: BehaviorSubject<boolean>;
  showItemList: BehaviorSubject<boolean>;
  testResult = new BehaviorSubject<any>("");
    // choosenAnswer = {
  //   questionId : undefined,
  //   optionId :[] as any
  // }

  constructor(private http: HttpClient, private loaderService: LoaderService,
    private notificationService: NotificationService
  ) {
    this.saveAnswer$ = new BehaviorSubject<any>(this.savedAnswers);
    this.itemName$ = new BehaviorSubject<any>('')
    this.questionAttempted = new BehaviorSubject<boolean>(false);
    this.showTools = new BehaviorSubject<boolean>(false);
    this.showItemList = new BehaviorSubject<boolean>(false);
  }

  createAnswers(testuuId: any, usertestuuId: any, questionuuId: any, optionId: any, type: number, choiceid?: any, stemid?: any, answer?: any, stemCount?: any) {
    let answerobj = {
      questionuuId: questionuuId,
      optionId: [] as any,
    }
    this.savedAnswers.testuuId = testuuId;
    this.savedAnswers.userTestuuId = usertestuuId;
    const qindex = this.savedAnswers.answers.findIndex((element: any) => element['questionuuId'] == questionuuId);
    if (qindex == -1) {
      answerobj.optionId.push(optionId);
      this.updateAttemptedProgress(1);
      this.savedAnswers.answers.push(answerobj);
    }
    else {
      if (type == 0) {
        // Multiple choice
        // Multiple Options
        let i = this.savedAnswers.answers[qindex]['optionId'].findIndex((t: any) => t == optionId);
        if (i == -1) {
          this.savedAnswers.answers[qindex]['optionId'].push(optionId);
        }
        else {
          this.savedAnswers.answers[qindex]['optionId'].splice(i, 1);
        }
        if (this.savedAnswers.answers[qindex]['optionId'].length == 0) {
          this.updateAttemptedProgress(-1);
        } else if (this.savedAnswers.answers[qindex]['optionId'].length == 1) {
          this.updateAttemptedProgress(1);
        }
      }
      else if (type == 1) {
        // Multiple choice
        // Standard
        this.savedAnswers.answers[qindex]['optionId'].length = 0;
        this.savedAnswers.answers[qindex]['optionId'].push(optionId)
      }
      else {
        this.savedAnswers.answers[qindex]['optionId'].length = 0;
        this.savedAnswers.answers[qindex]['optionId'].push(optionId);
      }
    }

    this.saveAnswer$.next(this.savedAnswers);
    return this.savedAnswers;
  }

  vocieNo(data) {
    this.voiceNo.next(data)
  }
  titleNameFunction(data) {

    this.titleNameTest.next(data)
  }
  pdfT(data) {

    // this.pdfToggleBtn =
    if (this.pdfToggleBtn == data) {
      this.pdfToggleBtn = !data
    } else {
      this.pdfToggleBtn = data
    }

    this.pdfToggle.next(data)
    this.sentclick();
  }
  sentclick() {

    this.subjectPdf.next()
  }
  getclick(): Observable<any> {
    return this.subjectPdf.asObservable()
  }
  toggleF(data) {
    this.togleIcon.next(data)
  }
  getLocalSavedAnswers() {
    return this.savedAnswers;
  }

  getNextEventChenge() {
    this.getNextPageEvent.next("click")
  }
  getclickNextEventChenge(): Observable<any> {
    return this.getNextPageEvent.asObservable()
  }

  submitTestQuestions(): Observable<any> {
    const data = JSON.stringify(this.savedAnswers);

    return this.http.post<any>(Delivery.Question, data, { 'headers': { 'content-type': 'application/json' } })
  }

  getTest(useruuid: any) {
    return this.http.get<any>(Delivery.GetTest + useruuid + '/tests')
  }


  getExamineeTest(scheduleUId: any) {
    return this.http.get<any>(Delivery.ExamineeTest + scheduleUId).pipe(
      tap((data) => {
        data = data;
        sessionStorage.setItem('scheduleEndDate', data.scheduleEndDate);
        sessionStorage.setItem('SchId', scheduleUId)
      })
    )
  }

  getTestResult(userTestId: any, enrollment: any, timeOver?) {
    if (enrollment != '' && enrollment != undefined) {
      var enrollmentId = `?enrollmentId=${enrollment}`;
    } else {
      var enrollmentId = '';
    }

    if (timeOver) var enrollmentId = enrollmentId == '' ? ('?isautosubmit=' + timeOver) : (enrollmentId + '&isautosubmit=' + timeOver );
    return this.http.get<any>(Delivery.GetTest + userTestId + '/submit-test' + enrollmentId)
  }

  getAssessementTest(userTestId: any, enrollment: any, payload: any, timeOver?) {
    if (enrollment != '' && enrollment != undefined) {
      var enrollmentId = `?enrollmentId=${enrollment}`;
    } else {
      var enrollmentId = '';
    }

    if (timeOver) var enrollmentId = enrollmentId == '' ? ('?isautosubmit=' + timeOver) : (enrollmentId + '&isautosubmit=' + timeOver );
    return this.http.post<any>(Delivery.GetTest + userTestId + '/submit-assessment' + enrollmentId, payload)
  }

  getTestItems(testId: any, userTestId: any) {
    return this.http.get<any>(Delivery.TestItems + testId + '/items?' + 'userTestuuId=' + userTestId)
  }

  putUpdateTime(testId: any, userTestId: any): Observable<any> {
    const submitTestApiUrl = Delivery.GetTest + userTestId + '/test-timie/' + testId;
    this.loaderService.sentReqUrl(submitTestApiUrl)
    return this.http.get<any>(Delivery.GetTest + userTestId + '/test-timie/' + testId)
  }

  getTestQuestions(userTestuuId: any, itemuuId: any) {
    return this.http.get<any>(Delivery.TestItems + userTestuuId + '/items/' + itemuuId + '/questions');
  }

  submitTest(usertestuuId: any) {
    return this.http.get<any>(Delivery.GetTest + usertestuuId + '/test-timie')
  }

  getExamineeLoginTest(groupName: string) {
    return this.http.get<any>(Delivery.ExamineeLoginTest + `${groupName}`)
  }

  //#region 'Jaydeep Code Refactoring'
  updateAttemptedProgress(data: number) {
    this.validQuestionSubject.next(data);
  }

  setMatrixTypeAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) { this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(1); } }
    else { existingData.matrixAnswerModels = data.matrixAnswerModels; if (data.progress) { this.updateAttemptedProgress(0); } }
    this.saveAnswer$.next(this.savedAnswers);

  }

  setMatchOrderTypeAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);

    if (!existingData) { this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(data.progress); } }
    else { existingData.matchTheOrderAnswerModels = data.matchTheOrderAnswerModels; }
    this.saveAnswer$.next(this.savedAnswers);
  }

  setMatrixQuestionStatus(data: MatrixQuestionValidation) {
    const question = this.matrixQuestionValidations.find(d => d.QuestionId === data.QuestionId);
    if (question) { this.matrixQuestionValidations.find(d => d.QuestionId === data.QuestionId).IsValid = data.IsValid; }
    else { this.matrixQuestionValidations.push(data); }
    this.isValidToNextBack = this.matrixQuestionValidations.filter(d => !d.IsValid).length > 0 ? false : true;
  }

  setDescriptiveTypeAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }

    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) {
      this.savedAnswers.answers.push(data);
      if (data.progress && data.descriptiveTypeAnswers.answerDescription.description !== '') { this.updateAttemptedProgress(1); }
      if (!data.progress && data.descriptiveTypeAnswers.answerDescription.description === '') {
        this.updateAttemptedProgress(-1);
      }
    }
    else {
      if (existingData.descriptiveTypeAnswers.answerDescription.description === ''
        && data.descriptiveTypeAnswers.answerDescription.description !== '') { this.updateAttemptedProgress(1); }
      else if (existingData.descriptiveTypeAnswers.answerDescription.description !== ''
        && data.descriptiveTypeAnswers.answerDescription.description === '') {
        this.updateAttemptedProgress(-1);
      }
      this.savedAnswers.answers = this.savedAnswers.answers.filter(d => d.questionuuId !== data.questionuuId);
      this.savedAnswers.answers.push(data);
    }

    // this.questionsEvaluationDetailsData = this.savedAnswers
    this.saveAnswer$.next(this.savedAnswers);
  }

  setDescriptiveEvalutionData(data) {
    // console.log(data);

    let savedAnsData = this.savedAnswers.answers.filter(d => d.questionuuId == data.questionuuId);

    let evaluatePayload = {
      "questionid": data.questionId,
      "questiondescription": data.questiondescription.description,
      "answerDetails": {
        "id": 0,
        "optionId": data.optiId,
        "answerDescription": savedAnsData[0] != undefined ? savedAnsData[0].descriptiveTypeAnswers.answerDescription.description : (data.options[0].answerDescription != null ? data.options[0].answerDescription.description : ''),
        "correctPoints": savedAnsData[0] != undefined ? savedAnsData[0].descriptiveTypeAnswers.score : data.options[0].score,
        "answerValid": false,
        "selected": false
      },
      "questionTypeId": data.questionTypeId,
      "questionSubtypeId": data.questionSubTypeId,
      "questionOrder": data.displayOrder,
      "questionuuId": data.questionuuId,
      "itemDisplayOrder": data.itemDisplayOrder
    }

    if (!savedAnsData) {
      this.questionsEvaluationDetailsData.questionsEvaluationDetails.push(evaluatePayload);
    } else {
      this.questionsEvaluationDetailsData.questionsEvaluationDetails = this.questionsEvaluationDetailsData.questionsEvaluationDetails.filter(d => d.questionuuId !== data.questionuuId);
      this.questionsEvaluationDetailsData.questionsEvaluationDetails.push(evaluatePayload);
    }

    // console.log(this.questionsEvaluationDetailsData, 'dasd')
  }

  setGenderEvalutionData(data, item) {
    // console.log(data);

    let savedAnsData = this.savedAnswers.answers.filter(d => d.questionuuId == data.questionuuId);

    let evaluatePayload = {
      "questionid": data.questionId,
      "questiondescription": data.questiondescription.description,
      "answerDetails": data.item,
      "questionTypeId": data.questionTypeId,
      "questionSubtypeId": data.questionSubTypeId,
      "questionOrder": data.displayOrder,
      "questionuuId": data.questionuuId,
      "itemDisplayOrder": data.itemDisplayOrder
    }

    if (!savedAnsData) {
      this.questionsEvaluationDetailsData.questionsEvaluationDetails.push(evaluatePayload);
    } else {
      this.questionsEvaluationDetailsData.questionsEvaluationDetails = this.questionsEvaluationDetailsData.questionsEvaluationDetails.filter(d => d.questionuuId !== data.questionuuId);
      this.questionsEvaluationDetailsData.questionsEvaluationDetails.push(evaluatePayload);
    }

    // console.log(this.questionsEvaluationDetailsData, 'dasd')
  }

  setMultiChoiceAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) {
      data.isInProgress = true;
      this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(1); } else if (data.optionId.length == 0) {
        this.updateAttemptedProgress(-1);
      }
    }
    else {
      existingData.optionId = data.optionId;
      if (data.optionId.length > 1) existingData.isInProgress = true;
      if (data.optionId.length == 0) {
        existingData.isInProgress = data.isInProgress = false;
        this.updateAttemptedProgress(-1);
      } else if (data.optionId.length == 1 && data.progress && !existingData.isInProgress) {
        // this.updateAttemptedProgress(-1);
        this.updateAttemptedProgress(1);
      }
    }
    this.saveAnswer$.next(this.savedAnswers);
  }

  setMultiChoiceStandardAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) { this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(1); } }
    else { existingData.optionId = data.optionId }
    this.saveAnswer$.next(this.savedAnswers);
    this.isValidToNextBack =  this.savedAnswers.answers.length > 0 ? true : false;
  }

  setHotspotSingleChoice(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) { this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(1); } }
    else { existingData.optionId = data.optionId }
    this.saveAnswer$.next(this.savedAnswers);
    this.isValidToNextBack =  this.savedAnswers.answers.length > 0 ? true : false;
  }

  setHotspotMultiChoice(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) {
      data.isInProgress = true;
      this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(1); } else if (data.optionId.length == 0) {
        this.updateAttemptedProgress(-1);
      }
    }
    else {
      existingData.optionId = data.optionId;
      if (data.optionId.length > 1) existingData.isInProgress = true;
      if (data.optionId.length == 0) {
        existingData.isInProgress = data.isInProgress = false;
        this.updateAttemptedProgress(-1);
      } else if (data.optionId.length == 1 && data.progress && !existingData.isInProgress) {
        // this.updateAttemptedProgress(-1);
        this.updateAttemptedProgress(1);
      }
    }
    this.saveAnswer$.next(this.savedAnswers);
  }

  setSurveySingleChoiceAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) { this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(1); } }
    else { existingData.SurveyAnswerModel = data.SurveyAnswerModel }
    this.saveAnswer$.next(this.savedAnswers);
  }

  setSurveyShortAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId == data.questionuuId);
    if (!existingData) {
      this.savedAnswers.answers.push(data);
      if (data.progress) { this.updateAttemptedProgress(1); }
      if (!data.progress && data.SurveyAnswerModel[0].answerDescription.description === '') {
        this.updateAttemptedProgress(-1);
      }
    }
    else {
      if (existingData.SurveyAnswerModel[0].answerDescription.description === ''
        && data.SurveyAnswerModel[0].answerDescription.description !== '') { this.updateAttemptedProgress(1); }
      else if (existingData.SurveyAnswerModel[0].answerDescription.description !== ''
        && data.SurveyAnswerModel[0].answerDescription.description === '') {
        this.updateAttemptedProgress(-1);
      }
      this.savedAnswers.answers = this.savedAnswers.answers.filter(d => d.questionuuId !== data.questionuuId);
      this.savedAnswers.answers.push(data);
    }
    this.saveAnswer$.next(this.savedAnswers);
  }

  setSurveyMultiChoiceAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (!existingData) {
      this.savedAnswers.answers.push(data); if (data.progress) { this.updateAttemptedProgress(1); } else if (data.SurveyAnswerModel.length == 0) {
        this.updateAttemptedProgress(-1);
      }
    }
    else {
      existingData.SurveyAnswerModel = data.SurveyAnswerModel;
      existingData.optionId = data.optionId;
      if (data.SurveyAnswerModel.length == 0) {
        this.updateAttemptedProgress(-1);
      } else if (data.SurveyAnswerModel.length == 1 && data.progress) {
        this.updateAttemptedProgress(1);
      }
    }
    this.saveAnswer$.next(this.savedAnswers);
  }

  setFillInTheBlanksAnswer(data: any) {
    if (!this.savedAnswers.testuuId) {
      this.savedAnswers.testuuId = this.testDetails.testuuId;
      this.savedAnswers.userTestuuId = this.testDetails.userTestuuId;
    }
    const existingData = this.savedAnswers.answers.find(d => d.questionuuId === data.questionuuId);
    if (data.progress) { this.updateAttemptedProgress(data.progress); }
    if (!existingData) {
      this.savedAnswers.answers.push(data);
      // this.updateAttemptedProgress(1);
    }
    else {
      // if (!data.fillInTheBlankAnswers || !data.fillInTheBlankAnswers.filter(d => d.answerDescription.description).length) { this.updateAttemptedProgress(data.progress); }
      this.savedAnswers.answers = this.savedAnswers.answers.filter(d => d.questionuuId !== data.questionuuId);
      this.savedAnswers.answers.push(data);
    }
    this.saveAnswer$.next(this.savedAnswers);
  }
  //#endregion
}


export class MatrixQuestionValidation {
  QuestionId: string;
  IsValid: boolean;
}

